import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { GenericCommentsView, TitledContainerInner, EntityCardContent } from "components/common";
import { ShareRegisterFooter, ShareholderList, useShareRegisterSnoozeAction } from "components/shareRegister";
import { Grid } from "@mui/material";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const ShareRegisterTodoToApprove: React.FC<TodoCardProps> = (props) => {
  const snoozeAction = useShareRegisterSnoozeAction(props.item.id, props.onActionSuccess);
  // The API fills information only when Wint has sent the todo back, with the comment Wint wrote.
  const sentBackComment = props.item.information;

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          footerText={`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.AnswerBefore
          )}: ${DateHelper.formatDate(props.item.date)}`}
          quickActions={[snoozeAction]}
        />
      }
      todoMainSection={
        <TitledContainerInner
          header={
            sentBackComment
              ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.ShareRegister.ShareRegisterTodoSentBackHeader)
              : LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.ShareRegister.ShareRegisterTodoToApproveHeader
                )
          }
          subHeader={
            sentBackComment
              ? LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.ShareRegister.ShareRegisterTodoSentBackSubHeader,
                  "",
                  { comment: sentBackComment }
                )
              : LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.ShareRegister.ShareRegisterTodoToApproveSubHeader
                )
          }
        />
      }
      footer={
        <ShareRegisterFooter id={props.item.id} markAsDoneHandler={props.onActionSuccess} disableSuccessMessages />
      }
      infoViewer={
        <Grid container className={cssExports.todoTableContainer}>
          <ShareholderList />
        </Grid>
      }
    >
      <GenericCommentsView parentId={props.item.id} type={WintSuperkollAPIModel.GenericCommentType.ShareRegister} />
    </EntityCardContent>
  );
};

export default ShareRegisterTodoToApprove;
